import { Box, Link, Typography } from "@mui/material";
import dantonProfile from "@/assets/team/danton-mariano-upscaled-bw.webp";

export const TeamSection = () => (
  <Box
    component="section"
    aria-labelledby="about-founder"
    sx={{ py: { xs: 8, md: 13 }, borderTop: "1px solid", borderColor: "divider" }}
  >
    <Typography
      sx={{
        color: "secondary.main",
        fontSize: "0.68rem",
        fontWeight: 900,
        letterSpacing: "0.12em",
        mb: { xs: 3, md: 5 },
      }}
    >
      04 / BEHIND THE BOARD
    </Typography>
    <Typography
      id="about-founder"
      component="h2"
      sx={{
        maxWidth: 1050,
        fontSize: { xs: "clamp(2.6rem,13vw,4.8rem)", md: "clamp(4.5rem,7vw,7.8rem)" },
        fontWeight: 950,
        lineHeight: 0.82,
        letterSpacing: "-.085em",
        textTransform: "uppercase",
      }}
    >
      NOT A GENERIC COACH.
      <br />
      <Box component="span" sx={{ color: "secondary.main" }}>
        BUILT BY A PLAYER WHO NEEDED IT.
      </Box>
    </Typography>
    <Box
      sx={{
        mt: { xs: 4, md: 7 },
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: ".85fr 1.15fr" },
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      <Box
        sx={{
          position: "relative",
          minHeight: { xs: 340, md: 560 },
          bgcolor: "background.default",
          border: "2px solid",
          borderColor: "text.primary",
          boxShadow: "15px 15px 0 #ff3d12",
          overflow: "hidden",
        }}
      >
        <Box
          component="img"
          src={dantonProfile}
          alt="Danton Mariano, founder of Chessla"
          sx={{
            width: "100%",
            height: "100%",
            position: "absolute",
            inset: 0,
            objectFit: "cover",
            objectPosition: "center 18%",
          }}
        />
        <Box
          aria-hidden
          sx={{ position: "absolute", inset: "72% 0 0", background: "linear-gradient(180deg, transparent, #0a0a0a)" }}
        />
        <Typography
          sx={{
            position: "absolute",
            inset: "auto 16px 16px",
            color: "secondary.main",
            fontSize: ".7rem",
            fontWeight: 900,
            letterSpacing: ".08em",
          }}
        >
          DANTON MARIANO / FOUNDER &amp; ENGINEER
        </Typography>
      </Box>
      <Box sx={{ p: { xs: 2.5, sm: 4, lg: 6 }, display: "flex", flexDirection: "column", justifyContent: "center" }}>
        <Typography sx={{ maxWidth: 650, fontSize: { xs: "1rem", md: "1.18rem" }, lineHeight: 1.75 }}>
          Hi, I&apos;m Danton. I&apos;m building the tool I wish I had while trying to get better at chess myself.
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary", mt: 2, maxWidth: 650, lineHeight: 1.75 }}>
          Chessla began as a terminal script for making sense of one player&apos;s games. Using it consistently helped
          me improve by roughly 400 rating points in under three months. The real breakthrough was knowing what to look
          for before making the next move.
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary", mt: 2, maxWidth: 650, lineHeight: 1.75 }}>
          I&apos;m also the Founding Engineer behind{" "}
          <Link
            href="https://shotdata.io"
            target="_blank"
            rel="noreferrer"
            sx={{ color: "secondary.main", fontWeight: 900, textUnderlineOffset: 3 }}
          >
            shotdata.io
          </Link>
          . That work reinforced one standard: complex data only earns its place when it helps someone make a better
          decision.
        </Typography>
        <Link
          href="https://br.linkedin.com/in/danton-mariano"
          target="_blank"
          rel="noreferrer"
          sx={{
            alignSelf: "start",
            mt: 3,
            minHeight: 44,
            display: "inline-flex",
            alignItems: "center",
            color: "text.primary",
            borderBottom: "2px solid",
            borderColor: "secondary.main",
            fontSize: ".72rem",
            fontWeight: 900,
            letterSpacing: ".08em",
            textTransform: "uppercase",
            textDecoration: "none",
          }}
        >
          MEET ME ON LINKEDIN ↗
        </Link>
      </Box>
    </Box>
  </Box>
);
